import React from 'react';
import classnames from 'classnames';
import { flex } from 'scy/flex.mod.scss';
import {
  container,
  narrow,
  medium,
  wide,
  extraWide,
  asideContainer,
  mainContainer
} from './styles.mod.scss';

const NarrowContainer = ({ children, className, tag }) => {
  const Tag = tag || 'div';
  return (
    <Tag className={classnames(className, container, narrow)}>{children}</Tag>
  );
};

const MediumContainer = ({ children, className, tag }) => {
  const Tag = tag || 'div';
  return (
    <Tag className={classnames(className, container, medium)}>{children}</Tag>
  );
};

const WideContainer = ({ children, className, tag }) => {
  const Tag = tag || 'div';
  return (
    <Tag className={classnames(className, container, wide)}>{children}</Tag>
  );
};

const ExtraWideContainer = ({ children, className, tag }) => {
  const Tag = tag || 'div';
  return (
    <Tag className={classnames(className, container, extraWide)}>
      {children}
    </Tag>
  );
};

const MainPlusAsideContainer = ({
  className,
  tag,
  renderAside,
  renderMain
}) => {
  const Tag = tag || 'div';
  return (
    <Tag className={classnames(flex, className)}>
      <div className={asideContainer}>{renderAside()}</div>
      <div className={mainContainer}>{renderMain()}</div>
    </Tag>
  );
};

export {
  NarrowContainer,
  MediumContainer,
  WideContainer,
  ExtraWideContainer,
  MainPlusAsideContainer
};
